export default __webpack_public_path__ + "static/media/WWA.0dafa0da.webp";